'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AlertInfo = require('./components/AlertInfo.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlertInfo).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-alerts/lib/components/info/index.js
// module id = 876
// module chunks = 0 3